import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TrainingDate } from '../../models/training-date.interface'
import { TrainingAggregates } from '../../models/training-aggregates.interface'
import { ApiProvider } from '../../providers/api/api'
// import { LineUpPage } from '../../pages/line-up/line-up'

@IonicPage()
@Component({
  selector: 'page-training-overview',
  templateUrl: 'training-overview.html',
})
export class TrainingOverviewPage {
  filteredItems: TrainingDate[];
  plainItems: TrainingDate[];
  trainingStandings: {};

  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              private api: ApiProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TrainingOverviewPage');
    this.api.getTrainingOverview()
    .subscribe(result => { 
        console.log(result); 
        this.plainItems = result.TrainingDates;
        this.filterAndAggregate();
    });

    this.api.getEntity("statisticSummary", "TrainingResults")
    .subscribe(result => {
      this.trainingStandings = result[0].value;
      console.log(this.trainingStandings);
    });
  }

  trainingDateTapped($event: MouseEvent, item : any){
    console.log(item);
    // this.navCtrl.push(LineUpPage, { 'trainingDate' : item});
    this.navCtrl.push('LineUpPage', { 'id' : item.Id ,'trainingDate' : item});
  }

  filterAndAggregate(){
    
        var first = false; // true;
        this.filteredItems = new Array<TrainingDate>();
        for(var plainItem of this.plainItems)
        {
            // check for date
            if(!plainItem.Label.startsWith("Mon,"))
              continue;

            plainItem.Aggregates = <TrainingAggregates>{};  
            //
            plainItem.Aggregates.NumberOfPlayers = this.getNumberOfPlayers(plainItem);
            plainItem.Aggregates.NumberOfGoalies = this.getNumberOfGolies(plainItem);
            plainItem.Aggregates.First = first;
            if(first){
               first = false;
            }
            
            this.filteredItems.push(plainItem);
        }
      }
    
      getNumberOfPlayers(item: any) : number  {
        var numberOfPlayer = 0;
        for(var player of item.Players)
        {
            if(player.Name.startsWith("00-"))
              continue;
            
            numberOfPlayer++;
        }
        return numberOfPlayer;
      }
    
      getNumberOfGolies(item: any) : number  {
        var numberOfGoalies = 0;
        for(var player of item.Players)
        {
            if(!player.Name.startsWith("00-")
          || player.Name.startsWith("GG-"))
              continue;
            
              numberOfGoalies++;
        }
        return numberOfGoalies;
      }

      trainingResultsTapped() {
        console.log("trainingResultsTapped");
        this.navCtrl.push('ResultListPage');
      }
}



// WEBPACK FOOTER //
// ./src/pages/training-overview/training-overview.ts